/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <GlobalGraph class="graph" v-if="series.length" :series="computedSeries" :xAxisData="xAxis" :yAxis="yAxis" :theme="theme" :isOnClickValueRequired="true" />
</template>

<script>
import { mapGettersMixin } from '@/util/mixin/index'
import GlobalGraph from '@/components/common/GlobalGraph.vue'
import Inverter from '@/services/Inverter'
import {
  mapGetters,
  mapMutations
} from 'vuex'
const moment = require('moment')

export default {
  props: ['date', 'type'],
  mixins: [mapGettersMixin],
  components: {
    GlobalGraph
  },
  data() {
    return {
      loading: false,
      series: [],
      xAxis: []
    }
  },
  created() {
    this.setIntervalWithoutDelay(this.callAllApi)
  },
  computed: {
    ...mapGetters(['getSelectedPlantId']),
    enableComputedWatch() {
      return `${this.date[0]} ${this.date[1]} ${this.getSelectedPlantId}`
    },
    yAxis() {
      return [{
          type: 'value',
          name: this.$t('Generation (kWh)'),
          min: 0,
          position: 'right',
          axisLabel: {
            formatter: '{value}',
            rotate: 40
          }
        },
        {
          type: 'value',
          name: this.$t('Irradiance (W/m²)'),
          min: 0,
          position: 'left',
          axisLabel: {
            formatter: '{value}',
            rotate: 40
          }
        }
      ]
    },
    computedSeries() {
      const cloneSeries = _.cloneDeep(this.series)
      return cloneSeries.map(el => {
        el.name = this.$t(el.name)
        return el
      })
    }
  },
  methods: {
    ...mapMutations([
      'SET_LAST_CALL_TIME',
      'SET_PROGRESS_BAR'
    ]),
    callAllApi() {
      const updateTime = moment().format('MM-DD-YYYY H:mm:ss')
      this.SET_LAST_CALL_TIME(updateTime)
      this.generationData()
    },
    async generationData() {
      try {
        this.SET_PROGRESS_BAR(true)
        const param = {
          plantId: this.getSelectedPlantId,
          dateFrom: this.date[0],
          dateTo: this.date[1]
        }
        const response = await Inverter.getPlantGenration(param)
        this.SET_PROGRESS_BAR(false)
        const tempSeries = []
        tempSeries.push(response.data.message.generation)
        tempSeries.push(response.data.message.ws)
        this.series = [...tempSeries]
        this.xAxis = response.data.message.axis
      } catch (err) {
        this.SET_PROGRESS_BAR(false)
      }
    }
  },
  watch: {
    enableComputedWatch() {
      this.setIntervalWithoutDelay(this.callAllApi)
    },
    isReload() {
      if (this.isReload) {
        this.setIntervalWithoutDelay(this.callAllApi)
      }
    }
  }
}
</script>

<style scoped>
  .graph {
    width: 100%;
    height: 400px;
  }
</style>
